var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Trophy(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M10.018 12.89V15h2.05a1 1 0 1 1 0 2H5.935a1 1 0 0 1 0-2h2.05v-2.109a4.68 4.68 0 0 1-3.418-2.984C2.274 9.19 1 7.867 1 5.97c0-2.041 1.45-3.033 3.825-2.945l.023-.224C4.952 1.779 5.827 1 6.871 1h4.26c1.045 0 1.92.779 2.024 1.801l.021.207C15.551 2.921 17 3.913 17 5.954c0 1.894-1.27 3.217-3.557 3.933a4.675 4.675 0 0 1-3.425 3.004Zm1.647-4.48v-.055a2.61 2.61 0 0 0-.013-.236L11.132 3h-4.26L6.35 8.12a2.577 2.577 0 0 0-.013.26C6.338 9.827 7.53 11 9.002 11c.088 0 .177-.004.265-.013 1.364-.134 2.384-1.258 2.398-2.576Zm-7.314-.724.272-2.674c-1.206-.047-1.59.263-1.59.958 0 .714.399 1.28 1.318 1.716Zm9.348-.04c.884-.433 1.268-.992 1.268-1.692 0-.629-.315-.943-1.268-.962v2.654Z" }) })));
}
export default Trophy;
